<div class="container-fluid row_banner" style="overflow-x: hidden">
  <app-header></app-header>
  <!-- Edditor  -->
  <div class="container">
    <div
      class="row text-center justify-content-center"
      style="align-content: center"
    >
      <div class="col-lg-9 col-md-9 mb-4" id="footergrammartext">
        <h1
          class="w-100 fnt-w600-40"
          style="margin-top: 40px; font-size: 30px; font-weight: 700"
        >
          Plagiarism Checker
        </h1>
        <span
          class="w-100 d-inline-block main_text mt-40"
          style="font-size: 16px; font-weight: 500"
          >Work with an Al writing partner that helps you find the words you
          need to write that tricky email, to get your point across, to keep
          your work moving.
        </span>
      </div>
    </div>

    <div class="custom-card">
      <p
        class="text-left success-msg"
        *ngIf="got_recpatcha"
        [ngStyle]="{
          color: color,
          'background-color': '#f8d7da',
          padding: '2px'
        }"
      >
        <i class="fa fa-times-circle matr ml-1" aria-hidden="true"></i>
        {{ recaptcha_message }}
      </p>
      <div class="row row1">
        <div class="col-lg-1 col-md-2 col-12 icon-bar">
          <div class="icon-bar">
            <div
              class="icon-bar-img"
              id="uploadFileS"
              value="Browse"
              onclick="document.getElementById('upload').click();"
            >
              <app-icons-free-tools [name]="'pcIcon'" />
              <input
                id="upload"
                multiple
                data-name="upload-element"
                #fileInput
                accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
                type="file"
                (change)="uploadFileSaveRedirect($event)"
              />
            </div>
            <div class="icon-bar-img" (click)="openDropboxChooser()">
              <app-icons-free-tools [name]="'dropboxIcon'" />
            </div>
            <div class="icon-bar-img" (click)="gDriveUpload()">
              <app-icons-free-tools [name]="'googleIcon'" />
            </div>
          </div>
        </div>
        <div class="col-lg-11 col-md-12 col-12">
          <div class="row">
            <div class="col-lg-8 cols1" style="overflow-y: hidden">
              <div
                class="upload-section smargintop"
                #editor
                (click)="onclickeditor($event)"
                contenteditable="true"
                style="overflow-y: auto; overflow-x: hidden"
                contenteditable="true"
                (keyup)="getContent($event, text)"
                id="editor"
                spellcheck="false"
                data-gramm="false"
                style="overflow-y: auto !important; overflow-x: hidden"
              ></div>
              <div *ngIf="showParagraph" class="editSectionDiv">
                <div *ngFor="let content of contentArray">
                  <app-icons-free-tools [name]="'checktextIcon'" />
                  <h3 class="editor-heading">{{ content.header }}</h3>
                  <p class="paragraph">{{ content.paragraph }}</p>
                  <div class="upload-buttons">
                    <button
                      [ngClass]="{
                        paste: button.text === 'Sample Text',
                        click: button.text === 'Paste Text',
                        'default-class': true
                      }"
                      *ngFor="let button of content.buttons"
                      class="textButtons"
                      (click)="executeAction(button.action)"
                    >
                      <app-icons-free-tools [name]="button.icon" />{{
                        button.text
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <span *ngIf="char_count !== 0">
                <app-icons-free-tools
                  [name]="'deleteIcon'"
                  (click)="deleteText()"
                  class="icon-del"
                />
              </span>
            </div>
            <div class="col-lg-4 cols2">
              <div class="result-section smargintop">
                <!-- *ngIf="  !isMobile" -->
                <img
                  src="../../assets/images/plagiarism checker/result-section.svg"
                  class="result-section-img"
                  *ngIf="!plagresponse"
                  style="
                    position: relative;
                    top: 45%;
                    left: 33%;
                    text-align: center;
                    transform: translate(-50%, -50%);
                  "
                />

                <div id="" class="responsePlagDis" *ngIf="plagresponse">
                  <div class="unique-result-d">
                    <div
                      id="unique-result"
                      style="
                        border: 1px solid #bce4cb;
                        display: flex;
                        justify-content: space-between;
                        background: #effff5;
                        align-items: center;
                      "
                    >
                      <div
                        style="display: flex; flex-direction: column"
                        class="ms-2"
                      >
                        <span
                          style="
                            font-size: 15px;
                            font-weight: 500;
                            line-height: 30px;
                            text-align: left;
                          "
                        >
                          Unique
                        </span>
                        <span
                          style="
                            font-size: 24px;
                            font-weight: 700;
                            color: #78c000;
                          "
                        >
                          {{ uniquefinal }}%
                        </span>
                      </div>
                      <div style="margin-top: 7px" class="unique-result-circle">
                        <circle-progress
                          [percent]="uniquefinal"
                          [radius]="16"
                          outerStrokeLinecap="round"
                          [backgroundStrokeWidth]="0"
                          innerStrokeWidth="6"
                          [space]="-6"
                          [outerStrokeWidth]="6"
                          outerStrokeColor="#3EC85C"
                          [showInnerStroke]="true"
                          [animationDuration]="300"
                          [animation]="false"
                          [showBackground]="false"
                          [clockwise]="true"
                          [showZeroOuterStroke]="true"
                          [animationDuration]="0"
                          innerStrokeColor="#D0E4D5"
                          [showSubtitle]="false"
                          [showTitle]="false"
                          [showUnits]="false"
                        >
                        </circle-progress>
                      </div>
                    </div>
                    <div
                      id="unique-result"
                      style="
                        border: 1px solid #f2caca;
                        display: flex;
                        justify-content: space-between;
                        background: #ffefef;
                        align-items: center;
                      "
                    >
                      <div
                        style="display: flex; flex-direction: column"
                        class="ms-2"
                      >
                        <span
                          style="
                            font-size: 15px;
                            font-weight: 500;
                            line-height: 30px;
                            text-align: left;
                          "
                        >
                          Plagiarized
                        </span>
                        <span
                          style="
                            font-size: 24px;
                            font-weight: 700;
                            color: #e03737;
                          "
                        >
                          {{ finalresult }}%
                        </span>
                      </div>
                      <div
                        style="margin-top: 7px; margin-left: -8px"
                        class="unique-result-circle"
                      >
                        <circle-progress
                          [percent]="finalresult"
                          [radius]="16"
                          outerStrokeLinecap="round"
                          [backgroundStrokeWidth]="0"
                          innerStrokeWidth="6"
                          [space]="-6"
                          [outerStrokeWidth]="6"
                          outerStrokeColor="#E03737"
                          [showInnerStroke]="true"
                          [animationDuration]="300"
                          [animation]="false"
                          [showBackground]="false"
                          [clockwise]="true"
                          [showZeroOuterStroke]="true"
                          [animationDuration]="0"
                          innerStrokeColor="#FFD2D2"
                          [showSubtitle]="false"
                          [showTitle]="false"
                          [showUnits]="false"
                        >
                        </circle-progress>
                      </div>
                    </div>
                  </div>

                  <div class="uniq-re-view-con">
                    <h5 class="mt-2 uniq-re-view mt-1">
                      View Plagiarized Sources
                    </h5>
                    <div class="search-container">
                      <input
                        disabled
                        contenteditable="false"
                        type="text"
                        class="uniq-re-input"
                        [placeholder]="
                          summatches +
                          ' matches from ' +
                          sumofsources +
                          ' source'
                        "
                        name="search"
                        autocomplete="off"
                      />
                      <div
                        style="
                          margin-top: -51px;
                          float: none;
                          margin-left: 214px;
                        "
                      ></div>
                    </div>
                    <br />
                    <br />
                    <div
                      class="card uniq-re-cardP"
                      data-purpose="scrollable-box"
                      *ngFor="let row of plagListings; let i = index"
                      id="plag_id{{ row?.index }}"
                      style="
                        border-radius: 12px !important;
                        border: 1px solid #e3e3f0 !important;
                      "
                    >
                      <div
                        class="card-plag-header p-2"
                        id="heading{{ row?.match_id }}"
                      >
                        <div
                          class="card-title"
                          id="card-title{{ row?.match_id }}"
                          style="min-height: 40px"
                          style="cursor: auto"
                        >
                          <span
                            style="
                              cursor: pointer;
                              font-size: 16px;
                              display: flex;
                            "
                          >
                            <p>
                              <circle-progress
                                [percent]="percentageresult"
                                [radius]="20"
                                outerStrokeLinecap="round"
                                [backgroundStrokeWidth]="0"
                                innerStrokeWidth="3"
                                [space]="-3"
                                [outerStrokeWidth]="3"
                                outerStrokeColor="#E03737"
                                [showInnerStroke]="true"
                                [animationDuration]="300"
                                [animation]="false"
                                [showBackground]="false"
                                [clockwise]="true"
                                [showZeroOuterStroke]="true"
                                [animationDuration]="0"
                                innerStrokeColor="#FFD2D2"
                                [showSubtitle]="false"
                                titleFontSize="12"
                                unitsFontSize="16"
                                titleColor="#E03737"
                                unitsColor="#E03737"
                              ></circle-progress>
                            </p>
                            <p class="card-plag-simi">
                              {{ row.similarity_score.similar_words }} Similar
                              Words
                            </p>
                          </span>
                        </div>
                      </div>
                      <a
                        href="https://www.google.com/search?q=&quot;{{
                          row?.unique
                        }}&quot;"
                        target="_blank"
                        rel="noopener noreferrer"
                        ><span
                          class="google_link"
                          style="position: sticky"
                        ></span
                      ></a>
                      <div
                        id="collapse_plag_{{ row?.index }}"
                        class="collapse"
                        aria-labelledby="headin
                                                gOne_plag"
                        data-parent="#accordion_alerts"
                        style="cursor: auto"
                      >
                        <div class="card-body" id="plag" *ngIf="row.url">
                          <div class="row">
                            <div
                              class="col-md-12 col-lg-12"
                              style="
                                padding-right: 5px;
                                padding-left: 5px;
                                max-width: 90%;
                                margin-left: 20px;
                              "
                            >
                              <div class="plag_links">
                                <p id="urllist" style="text-align: initial">
                                  {{ row.sentence }}
                                </p>
                                <div
                                  class="compare_links"
                                  *ngFor="let row1 of row.url"
                                >
                                  <p
                                    id="urllist"
                                    style="
                                      color: #e75300;
                                      text-align: justify;
                                      cursor: pointer;
                                    "
                                    (click)="plaglinks(row1?.url)"
                                  >
                                    {{ row1.url.slice(0, 30) }}...
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <span
                        id="collapse_span_plag{{ row?.index }}"
                        style="
                          width: 350px;
                          height: 60px;
                          position: absolute;
                          top: 0;
                          left: 0;
                          cursor: pointer;
                        "
                        (click)="showDetailedSpanPlag(row?.index)"
                      ></span>
                    </div>

                    <br />
                  </div>
                </div>
              </div>
            </div>
            <div class="progress-loader-div cols3">
              <div class="progress-loader" *ngIf="loaderAlert"></div>
            </div>
            <div class="botom-btns cols4">
              <div
                class="botom"
                style="justify-content: space-between; width: 100%"
              >
                <div class="word-count-after">
                  <div class="d-flex align-items-center me-2 url">
                    <img
                      src="../../assets/images/plagiarism checker1/link.svg"
                      class="me-2 mt-1 ms-2"
                      style="width: 20.5px; height: 20.5px"
                      alt="Link Icon"
                    />
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Exclude URL"
                      [(ngModel)]="excludeURL"
                      (ngModelChange)="onInputChange(excludeURL)"
                      (paste)="onCopyPaste($event)"
                    />
                  </div>

                  <div class="word-char">
                    <span class="word-limit wordcountFont mr-1">
                      Words: {{ char_count === 0 ? 0 : word_count }}
                    </span>

                    <span class="wordcountFont marg15">
                      &nbsp;&nbsp;Total Characters: {{ char_count }}
                    </span>
                  </div>
                </div>
                <div class="tools">
                  <button
                    class="download-img tooltipss"
                    aria-label="Try Again"
                    (click)="handleButtonClick()"
                    *ngIf="showbottombuttons"
                  >
                    <img src="../../assets/images/About us-assets/Vector.png" />
                    <span class="tooltiptext">Retry</span>
                  </button>
                  <button
                    class="download-img tooltipss"
                    (click)="copyText()"
                    *ngIf="showbottombuttons"
                  >
                    <img
                      src="../../assets/images/About us-assets/copy-frame.svg"
                      alt=""
                    />
                    <span class="tooltiptext">Copy</span>
                    <span class="tooltiptext" id="copried_txt">Copied</span>
                  </button>
                  <button
                    class="mr-1 unquieBtn"
                    (click)="downloadpdffile()"
                    *ngIf="showbottombuttons"
                  >
                    <img
                      src="../assets/images/plagiarism checker1/downPlag.svg"
                      alt="download-img"
                    />
                    <span> Download Report </span>
                  </button>
                </div>
              </div>

              <!-- CAPTCHA Modal (Popup) -->
              <div *ngIf="captchaVisible" class="captcha-modal-overlay">
                <div class="captcha-modal">
                  <div
                    id="recaptcha-container"
                    class="recaptcha-container"
                    data-size="compact"
                    data-theme="light"
                  ></div>
                </div>
              </div>

              <!-- Button to trigger CAPTCHA -->

              <button
                class="btn btn-dark btn-summarize"
                (click)="handleButtonClick()"
              >
                Check Plagiarism
              </button>

              <!-- Error message for CAPTCHA -->
              <p *ngIf="recaptchaMessage" [style.color]="color">
                {{ recaptchaMessage }}
              </p>
            </div>
          </div>

          <!-- code for validation  -->
          <div
            *ngIf="error"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="error"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="errorIcon" />

              <div style="width: 440px; height: auto; margin-left: 10px">
                <p
                  class="error mt-4 content-div-p"
                  style="
                    font-size: 20px;
                    font-weight: 500;
                    line-height: 33.89px;
                  "
                >
                  {{ errorAlerts }}
                </p>
              </div>

              <button class="mt-1 butn-alert" (click)="closeErrorDiv()">
                Ok
              </button>
            </div>
          </div>

          <div
            *ngIf="success"
            class="backdrop"
            style="
              position: fixed;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 1000;
            "
          ></div>

          <div
            *ngIf="success"
            class="content-div"
            style="
              position: fixed;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 468px;
              height: 360px;
              background-color: white;
              z-index: 1010;
              border-radius: 4px;
              border: 1px solid white;
            "
          >
            <div class="text-center" style="margin-top: 9%">
              <app-icons-free-tools name="successIcon" />
              <p
                *ngIf="success"
                class="error mt-4 content-div-p"
                style="font-size: 24px; font-weight: 500; line-height: 33.89px"
              >
                {{ successAlert }}
              </p>
            </div>
          </div>
          <!-- code for validation  -->
        </div>
      </div>
    </div>
    <div
      class="container justify-content-center"
      id="how-to-use-bg "
      style="margin-top: 100px"
    >
      <div class="row" style="box-sizing: border-box" id="plag-check">
        <div class="col-lg-12 justify-content-center" id="align-center">
          <h2 class="text-center plag-cont">
            How do you check for plagiarism in content?
          </h2>
          <p class="fnt-18-400 text-center mt-4">
            Detecting plagiarism from a written text becomes a simple executable
            task with our online plagiarism checker. By following the simple
            steps shared below, you can easily find copied text from content.
          </p>
        </div>
      </div>
    </div>
    <div
      class="container-fluid"
      id="how-to-use-bg "
      style="margin-top: 40px; justify-content: center; text-align: center"
    >
      <div class="container">
        <div class="row p-md-3" id="plag-check-content">
          <div
            class="col-xl-3 col-lg-6 col-md-6 mb-3"
            *ngFor="let step of plagiarismSteps"
          >
            <div class="tabs-plag col">
              <app-icons-free-tools
                [name]="step.icon"
                style="float: left"
                class="ms-3"
              />
              <p style="float: left">{{ step.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end section 2 -->
  </div>
</div>

<div class="container mb-4">
  <app-premium />
</div>

<!-- Section 3 -->
<div class="container justify-content-center" id="para-key-main">
  <div class="container">
    <div class="row">
      <h2 class="fnt-w600-40 text-center">
        Why Should You Use Our Plagiarism Checker?
      </h2>
      <p style="text-align: center; margin-top: 20px" class="fnt-18-400">
        Our state-of-the-art plagiarism-checking software gives its users an
        interrupted way to detect instances of plagiarism in any content.
        <br />
        Below are some other primary features of this web-based
        plagiarism-checking tool.
      </p>
      <div class="col-12">
        <div class="tabs_wrapper mt-4">
          <div class="btns-divs">
            <button
              *ngFor="let tab of plagiarismTabs"
              class="mybtn"
              [ngClass]="{ active: selectedTab === tab.id }"
              (click)="selectTab(tab.id)"
            >
              <app-icons-free-tools [name]="tab.icon" class="icon" />
              <h3 class="section-plag-tabs-p m-0">{{ tab.text }}</h3>
            </button>
          </div>

          <div
            class="tab_container"
            style="background-color: #f7f7fa; border-radius: 8px"
          >
            <div *ngIf="selectedTab === 'tab1'" class="tab_content">
              <p id="contentss">
                Our plagiarism checker uses highly advanced AI technology that
                makes it capable of detecting any minor duplication in your
                written content. The backend algorithms scan your entered text
                and compare it with billions of articles, essays, and other
                published articles from its database. Using a deep search
                method, this tool will offer a plagiarism search and additional
                result details.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab2'" class="tab_content">
              <p id="contentss">
                The web-based plagiarism checker is a completely free-to-use
                tool for every user. With this tool, users from any part of the
                planet can verify the genuineness of any written piece of
                content. Moreover, this tool doesn't require application
                installation to detect duplication in any text. Simply connect
                your device to the internet, and you are all set to check for
                plagiarism in any content straightaway.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab3'" class="tab_content">
              <p id="contentss">
                Unlike most plagiarism-checking utilities, our tool doesn't
                impose any restrictions on checking their text files. With this
                free plagiarism checker, they can detect duplication in as many
                text files as they require without observing any obstacles.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab4'" class="tab_content">
              <p id="contentss">
                Accuracy of the plagiarism check results will be guaranteed. The
                advanced algorithms are capable of offering you the quickest and
                100% most reliable results. You can double-check the accuracy of
                the generated plagiarism-checking results with any other
                web-based tool.
              </p>
            </div>
            <div *ngIf="selectedTab === 'tab5'" class="tab_content">
              <p id="contentss">
                Our free similarity checker offers its users multiple ways to
                upload content. You can paste the text in the given field or
                paste the text file directly on this plagiarism checker by
                tapping on the upload button.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container"
  style="margin-top: 50px; box-sizing: border-box; text-align: left"
  id="para-key-phone"
>
  <h2
    style="
      text-align: center;
      font-size: 30px;
      font-weight: 700;
      line-height: 37.8px;
      text-align: center;
    "
  >
    Why Should You Use Our Plagiarism Checker?
  </h2>
  <div
    class="col-md-12"
    style="
      text-align: center;
      font-size: 16px;
      font-weight: 500;
      line-height: 30px;
    "
  >
    <p>
      Our state-of-the-art plagiarism-checking software gives its users an
      interrupted way to detect instances of plagiarism in any content. Below
      are some other primary features of this web-based plagiarism-checking
      tool.
    </p>
  </div>
  <div
    class="v-pills-tab-list row"
    id="v-pills-tab-list"
    style="width: -webkit-fill-available"
  >
    <div class="" id="row_faqs">
      <div
        class="nav flex-column nav-pills"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          class="card active"
          id="v-pills-first-tab"
          aria-controls="q122"
          aria-expanded="false"
          class="mb-0 collapsed"
          data-toggle="collapse"
          href="#q122"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne_One"
              aria-expanded="true"
              aria-controls="collapseOne_One"
              class="card-header headingsize"
            >
              Advanced Technology</span
            >
            <i class="fas fa-chevron-down float-right down"></i>
          </h5>
          <div
            aria-labelledby="q122"
            class="collapse"
            id="q122"
            role="tabpanel"
            data-parent="#v-pills-tab-list"
          >
            <div class="card-body">
              Our plagiarism checker uses highly advanced AI technology that
              makes it capable of detecting any minor duplication in your
              written content. The backend algorithms scan your entered text and
              compare it with billions of articles, essays, and other published
              articles from its database. Using a deep search method, this tool
              will offer a plagiarism search and additional result details.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          class="card active"
          id="v-pills-2nd-tab"
          aria-controls="q12"
          aria-expanded="false"
          class="mb-0 collapsed"
          data-toggle="collapse"
          href="#q64"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne_One"
              aria-expanded="true"
              aria-controls="collapseOne_One"
              class="card-header headingsize"
            >
              Free to Use</span
            >
            <i class="fas fa-chevron-down float-right down"></i>
          </h5>
          <div
            aria-labelledby="q122"
            class="collapse"
            id="q64"
            role="tabpanel"
            data-parent="#v-pills-tab-list"
          >
            <div class="card-body">
              The web-based plagiarism checker is a completely free-to-use tool
              for every user. With this tool, users from any part of the planet
              can verify the genuineness of any written piece of content.
              Moreover, this tool doesn't require application installation to
              detect duplication in any text. Simply connect your device to the
              internet, and you are all set to check for plagiarism in any
              content straightaway.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          class="card active"
          id="v-pills-2nd-tab"
          aria-controls="q12"
          aria-expanded="false"
          class="mb-0 collapsed"
          data-toggle="collapse"
          href="#q74"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne_One"
              aria-expanded="true"
              aria-controls="collapseOne_One"
              class="card-header headingsize"
              >Unlimited File Checking</span
            >
            <i class="fas fa-chevron-down float-right down"></i>
          </h5>
          <div
            aria-labelledby="q12"
            class="collapse"
            id="q74"
            role="tabpanel"
            data-parent="#v-pills-tab-list"
          >
            <div class="card-body">
              Unlike most plagiarism-checking utilities, our tool doesn't impose
              any restrictions on checking their text files. With this free
              plagiarism checker, they can detect duplication in as many text
              files as they require without observing any obstacles.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          class="card active"
          id="v-pills-2nd-tab"
          aria-controls="q12"
          aria-expanded="false"
          class="mb-0 collapsed"
          data-toggle="collapse"
          href="#q81"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne_One"
              aria-expanded="true"
              aria-controls="collapseOne_One"
              class="card-header headingsize"
              >100% Accurate Results</span
            >

            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            aria-labelledby="q12"
            class="collapse"
            id="q81"
            role="tabpanel"
            data-parent="#v-pills-tab-list"
          >
            <div class="card-body">
              Accuracy of the plagiarism check results will be guaranteed. The
              advanced algorithms are capable of offering you the quickest and
              100% most reliable results. You can double-check the accuracy of
              the generated plagiarism-checking results with any other web-based
              tool.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          class="card active"
          id="v-pills-2nd-tab"
          aria-controls="q12"
          aria-expanded="false"
          class="mb-0 collapsed"
          data-toggle="collapse"
          href="#q89"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#collapseOne_One"
              aria-expanded="true"
              aria-controls="collapseOne_One"
              class="card-header headingsize"
              >Multiple Uploading Options</span
            >

            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            aria-labelledby="q12"
            class="collapse"
            id="q89"
            role="tabpanel"
            data-parent="#v-pills-tab-list"
          >
            <div class="card-body">
              Our free similarity checker offers its users multiple ways to
              upload content. You can paste the text in the given field or paste
              the text file directly on this plagiarism checker by tapping on
              the upload button.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
      </div>
    </div>
  </div>
</div>

<div class="container-fluid my-5" style="background-color: #ecf6f5">
  <div class="container">
    <div
      class="row justify-content-center"
      style="display: flex; align-items: center; padding: 30px 0px"
    >
      <div class="col-lg-7 col-md-12 left-section">
        <h2 class="freeGrammarFont" id="align-center">
          How Does Our AI Plagiarism Checker Work?
        </h2>
        <p class="freeGrammarFont-p mt-4" id="align-center">
          We are offering our users the best and most highly advanced
          duplication finder tool that will surely make their lives easier. With
          the assistance of this online plagiarism checker, you will certainly
          control the uniqueness of your written work. Once you enter any
          textual content on this facility, it will scan and compare the text
          with millions of web pages, articles, and other published content. The
          entire process will be completed within a few seconds, and you will
          get 100% flawless and reliable plagiarism-checking results. This helps
          students, teachers, researchers, journalists, and authors to maintain
          their integrity and make sure their curated content is genuine and
          free of plagiarism.
        </p>
      </div>
      <div class="col-lg-5 col-md-12 right-section">
        <img
          class="how-to-img"
          src="../assets/images/plagiarism checker1/How Does Our AI Plagiarism Checker Work-illustration.svg "
          alt="text-ig"
        />
      </div>
    </div>
  </div>
</div>
<!-- End Section 4 -->
<!-- Section 5 -->
<div class="container-fluid" id="plag-Consequences">
  <div class="container">
    <div class="row">
      <h2 class="fnt-w600" style="text-align: center">
        Consequences of Plagiarism
      </h2>
      <p class="fnt" style="text-align: center">
        Plagiarism is a terrible act that can lead an individual to face severe
        challenges. Below are <br class="d-md-block d-none" />
        some major consequences of submitting plagiarized content.
      </p>
    </div>
  </div>
</div>
<!-- End Section 5 -->
<!--  Section 6 -->
<div
  class="container-fluid"
  style="box-sizing: border-box"
  id="plag-Consequences-content"
>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-6" id="plag-6">
        <div class="border std" style="border-radius: 8px">
          <div class="d-flex mb-4">
            <app-icons-free-tools name="studentsIcon" class="me-4" />
            <h3 class="mt-2">Students</h3>
          </div>
          <div>
            <p class="fnt-16" style="font-size: 16px">
              Students are required to maintain academic integrity and submit
              their own crafted content to their instructors. Many students
              prefer duplicating others' work instead of relying on their
              skills, and this makes them vulnerable to various penalties.
              Therefore, it is essential for students to make sure their created
              content is free of any duplication to save their reputation and
              any miserable situation. Our top-notch plagiarism checker gives
              them the perfect way to check for plagiarism in their written
              work. Using this online utility, they can effortlessly ensure the
              genuineness of their work.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6" id="plag">
        <div class="cpywrte border" style="border-radius: 8px">
          <div class="d-flex mb-4">
            <app-icons-free-tools name="copywritersIcon" class="me-4" />
            <h3 class="mt-3">Copywriters</h3>
          </div>
          <div>
            <p style="font-size: 16px" class="fnt-16">
              Copywriters need to provide the best quality content to maintain
              their credibility. It is essential for them to offer 100% unique
              content to their clients to earn their appreciation and get more
              work in the future. If plagiarism is found in their work, then it
              will become almost impossible for them to get paid assignments.
              With our AI plagiarism checker, they can make sure their work is
              original.
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 jurnlts" id="plag">
        <div class="cpywrte border" style="border-radius: 8px">
          <div class="d-flex mb-4">
            <app-icons-free-tools name="journalistsIcon" class="me-4" />
            <h3 class="mt-3">Journalists</h3>
          </div>
          <div>
            <p style="font-size: 16px" class="fnt-16">
              Journalists are expected to provide their readers with entirely
              unique information. Failing to do so will surely make them lose
              the trust and loyalty of their readers and publishers. Journalists
              are given clear instructions that they must produce original and
              well-cited content. That's where our plagiarism comes to rescue
              them.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="container justify-content-center"
  id="use-guide-section-phone"
  style="margin-top: 100px"
>
  <div
    class="v-pills-tab-list row"
    id="use-guide-tab-list"
    style="width: -webkit-fill-available"
  >
    <div id="faqs-row">
      <div
        class="nav flex-column nav-pills"
        id="use-guide-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        <!-- First Tab -->
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="ai-tech-tab"
          aria-controls="ai-tech-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#ai-tech-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#ai-tech-collapse"
              aria-expanded="true"
              aria-controls="ai-tech-collapse"
              class="card-header headingsize"
              >Students</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="ai-tech-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Students are required to maintain academic integrity and submit
              their own crafted content to their instructors. Many students
              prefer duplicating others' work instead of relying on their
              skills, and this makes them vulnerable to various penalties.
              Therefore, it is essential for students to make sure their created
              content is free of any duplication to save their reputation and
              any miserable situation. Our top-notch plagiarism checker gives
              them the perfect way to check for plagiarism in their written
              work. Using this online utility, they can effortlessly ensure the
              genuineness of their work.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <!-- Second Tab -->
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="fast-free-tab"
          aria-controls="fast-free-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#fast-free-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#fast-free-collapse"
              aria-expanded="true"
              aria-controls="fast-free-collapse"
              class="card-header headingsize"
              >Copywriters</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="fast-free-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Copywriters need to provide the best quality content to maintain
              their credibility. It is essential for them to offer 100% unique
              content to their clients to earn their appreciation and get more
              work in the future. If plagiarism is found in their work, then it
              will become almost impossible for them to get paid assignments.
              With our AI plagiarism checker, they can make sure their work is
              original.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
        <!-- Third Tab -->
        <a
          class="nav-link nav-pills"
          style="margin: 8px 0; padding: 10px 14px; background: #fff"
          id="unique-text-tab"
          aria-controls="unique-text-collapse"
          aria-expanded="false"
          data-toggle="collapse"
          href="#unique-text-collapse"
        >
          <h5>
            <span
              class="btn active"
              type="button"
              data-toggle="collapse"
              data-target="#unique-text-collapse"
              aria-expanded="true"
              aria-controls="unique-text-collapse"
              class="card-header headingsize"
              >Journalists</span
            >
            <i class="fas fa-chevron-down float-right"></i>
          </h5>
          <div
            id="unique-text-collapse"
            class="collapse"
            role="tabpanel"
            data-parent="#use-guide-tab-list"
          >
            <div class="card-body">
              Journalists are expected to provide their readers with entirely
              unique information. Failing to do so will surely make them lose
              the trust and loyalty of their readers and publishers. Journalists
              are given clear instructions that they must produce original and
              well-cited content. That's where our plagiarism comes to rescue
              them.
            </div>
          </div>
        </a>
        <hr style="margin-top: 0px; margin-bottom: 0px" />
      </div>
    </div>
  </div>
</div>

<div class="container mt-5 qustion" id="home-faqs">
  <div
    class="row row justify-content-center"
    id="row_faqs"
    style="margin-bottom: 20px"
  >
    <div class="faqs text-center">
      <h1 class="text-center">Frequently asked questions</h1>
      <p style="text-align: center" class="text mb-5 text">
        Learn more about platform by user questions
      </p>
    </div>
    <div class="v-pills-tab-list row" id="v-pills-tab-list">
      <div id="row_faqs">
        <div
          class="container container-grid"
          style="width: min(100% - 40px, 768px)"
        >
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q5' }"
              (click)="toggleTab('q5')"
              id="v-pills-first-tab"
              aria-controls="q5"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q5'"
                >
                  What Is Plagiarism?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q5'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q5'"
                />
              </div>

              <div
                aria-labelledby="q5"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q5' }"
                id="q5"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Plagiarism is the duplication of others' work and presents it
                  as their own creation. Stealing anyone's work and sharing your
                  crafted work is a serious crime that can lead an individual to
                  face serious complications.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q15' }"
              (click)="toggleTab('q15')"
              id="v-pills-2nd-tab"
              aria-controls="q15"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q15'"
                >
                  Is This Plagiarism Checker Secure to Use?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q15'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q15'"
                />
              </div>

              <div
                aria-labelledby="q15"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q15' }"
                id="q15"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  incorporates the most advanced technology that makes sure no
                  third party can access your confidential information.
                  Moreover, all the data you upload will be erased from our
                  servers once you get the detailed duplication result report.
                  Hence, you shouldn't think of the secrecy of your confidential
                  textual content while using this free plagiarism checker.
                </div>
              </div>
            </a>
          </div>
          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q6' }"
              (click)="toggleTab('q6')"
              id="v-pills-4th-tab"
              aria-controls="q6"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q6'"
                >
                  Do I Need to Sign up for Checking Duplication with This Tool?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q6'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q6'"
                />
              </div>

              <div
                aria-labelledby="q6"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q6' }"
                id="q6"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Not at all! The users don't need to install any application or
                  share their personal information to use this free plagiarism
                  checker. With this utility, you can verify the originality of
                  the text without facing any such hurdles.
                </div>
              </div>
            </a>
          </div>

          <div
            class="nav flex-column nav-pills"
            id="v-pills-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link nav-pills"
              style="
                border: 1px solid #eaeaea;

                padding: 10px 14px;
                background-color: #f3f8fc;
                border-radius: 10px;
              "
              [ngClass]="{ active: activeTab === 'q7' }"
              (click)="toggleTab('q7')"
              id="v-pills-5th-tab"
              aria-controls="q7"
              aria-expanded="false"
              class="mb-0 collapsed"
            >
              <div class="nav-linkFAQ">
                <h3
                  class="card-header ms-3"
                  [class.closed]="activeTab !== 'q7'"
                >
                  Does This Similarity Checker Detect Patchwork Plagiarism?
                </h3>
                <app-icons-free-tools
                  name="plusIcon"
                  *ngIf="activeTab !== 'q7'"
                />
                <app-icons-free-tools
                  name="minusIcon"
                  *ngIf="activeTab === 'q7'"
                />
              </div>

              <div
                aria-labelledby="q7"
                class="collapse"
                [ngClass]="{ show: activeTab === 'q7' }"
                id="q7"
                role="tabpanel"
                data-parent="#v-pills-tab-list"
              >
                <div class="card-body carbody ms-3 me-3">
                  Of course! This utility has the ability to identify any type
                  of plagiarism, including patchwork plagiarism in submitted
                  content.
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- End Section 10 -->
<app-feedback></app-feedback>

<a
  (click)="scrollToTop()"
  *ngIf="shouldShowButton"
  id="scroll-to-top"
  data-tooltip="Go to top"
>
  <app-icons-free-tools name="goToTopIcon" />
</a>

<app-premium-modal-startup />

<app-footer></app-footer>
